import { CardType } from '../../Prototype/Level/Card/CardType';
import { ICardStateData } from './ICardState';
import { DEFAULT_CARD_HEIGHT, DEFAULT_CARD_WIDTH } from 'Prototype/Level/Card/ICardData';
import Point from 'Utility/Point';

export const initialCardStateData: ICardStateData = {
    id: '',
    type: CardType.value,
    random: false,
    value: undefined,
    faceUp: false,
    sequence: 0,
    modifiers: [],
    attempts: 0,
    x: 0,
    y: 0,
    rotation: 0,
    depth: 0,
    width: DEFAULT_CARD_WIDTH,
    height: DEFAULT_CARD_HEIGHT,
    scale: Point.One,
    offset: Point.Zero,
};
